import React from 'react';
import clsx from 'clsx';

type SlugProps = {
  text: React.ReactNode;
  tooltip?: string;
  color?: SlugColorType;

  className?: string;
};

const colorsMap: { [x in SlugColorType]: string } = {
  main: 'bg-[#6366f133] text-[#6366f1]',
  gray: 'bg-[#6b728033] text-[#9ca3af]',
  danger: 'bg-[#ef444433] text-[#ef4444]',
  success: 'bg-[#10b98133] text-[#10b981]',
  warning: 'bg-[#f59e0b33] text-[#f59e0b]',
};

const Slug: React.FC<SlugProps> = ({ text, color, tooltip, className }) => {
  return (
    <div
      title={tooltip}
      className={clsx(
        className,
        'truncate',
        'px-sm py-xs font-medium text-tiny rounded-md text-center',
        colorsMap[color || 'main']
      )}
    >
      {text}
    </div>
  );
};

export default React.memo(Slug) as typeof Slug;
